import { useState } from "react";

import CustomModal from "@components/CustomModal";

import useExportMembers from "./hooks/useExportMembers";
import ExportMembersView from "./view";

export default function ExportMembersModal({ modalRef }) {
  const [open, setOpen] = useState(false);
  const [communityId, setCommunityId] = useState(null);
  const [filtersSnapshot, setFiltersSnapshot] = useState(null);

  modalRef.current = {
    open(id, snapshot = null) {
      setCommunityId(id);
      setFiltersSnapshot(snapshot);
      setOpen(true);
    },
    close() {
      setOpen(false);
    },
  };

  const state = useExportMembers({ communityId, open, filtersSnapshot });

  const handleClose = () => setOpen(false);

  const handleSubmit = () => state.submit(handleClose);

  return (
    <ExportMembersView
      {...state}
      ModalComponent={CustomModal}
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
    />
  );
}
